// Klassen zusammensetzen: clsx + tailwind-merge, mit den Merxo-Tokens bekannt gemacht (sonst hielte
// tailwind-merge `text-dense` für eine Textfarbe und würde es neben `text-fg` verwerfen).
import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ['micro', 'caption', 'dense', 'body', 'touch', 'title', 'heading', 'display', 'hero'],
      radius: ['xs', 'sm', 'md', 'lg', 'xl'],
      shadow: ['xs', 'sm', 'md', 'lg', 'focus'],
    },
  },
})

export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs))
